<!-- eslint-disable vue/valid-template-root -->
<template lang="html">
  <Col :span="24">
  <Card class="card-box">
    <div slot="header">
      PickUps
    </div>
    <div class="text-center" v-if="!etaCompliance">
      <Spinner />
    </div>
    <div class="status-msg" v-else-if="!etaCompliance">
      <span>
        <svgicon :name="emptyDashboardIcon" width="150" height="115" :original="true" />
        <p class="mt-0 ml-30">No data available</p>
      </span>
    </div>
    <Row :gutter="40" class="list-bordered" v-else>
      <Col :span="6" v-for="header in pickupHeaders" :key="header.id" :class="header.class">
      <Tooltip :open-delay="100" popper-class="max-width" effect="dark" placement="top">
        <div slot="content">
          <span v-html="trackingDashboard[header.column]"></span>
        </div>
        <ColCell :header="header" :value="etaCompliance[header.column]"
          @routeToTrack="$emit('routeToTrack', { routeCategory: 'dashboardFilter', header: $event })">
        </ColCell>
      </Tooltip>
      </Col>
    </Row>
  </Card>
  </Col>
</template>

<script>
import ColCell from '@/components/track/ColCell';
import Graph from '@/components/track/Graph';
import {
  etaDetailsHeaders,
  etaBarChartConstants,
  pickupHeaders,
} from '@/constants/trackConstants';
import SecFilterMixin from '@common/mixins/SecFilterMixin';

export default {
  components: {
    ColCell,
    Graph,
  },
  mixins: [SecFilterMixin],
  data() {
    return {
      etaBarChartConstants,
      etaDetailsHeaders,
      pickupHeaders,
    };
  },
  props: ['etaCompliance', 'isEtaComplianceLoading', 'emptyDashboardIcon', 'trackingDashboard'],
  methods: {
    routeToTrack(category, header) {
      if (header.routerActive) {
        const dateRange = this.findByCategory(this.filters.DATE);
        const transporter = this.findByCategory(this.filters.TRANSPORTER);
        let query = {
          fromDashboard: true,
          start: dateRange.startDate && this.$moment(dateRange.startDate).startOf('day').toISOString(),
          end: dateRange.startDate && this.$moment(dateRange.endDate).startOf('day').toISOString(),
        };
        if (transporter && transporter.id && transporter.id !== -1) {
          query = Object.assign(query, { trans: transporter.name, transporterId: transporter.id });
        }
        if (category) {
          const obj = {};
          obj[category] = header.routerValue;
          query = Object.assign(query, obj);
        }
        if (header.routerParent) {
          query = Object.assign(query, header.routerParent);
        }
        this.$router.push({ name: 'Trips', query });
      }
    },
  },
};
</script>
